import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';
import store_config from "@/store/mods/parametres/config"
import store_consultation from "@/store/mods/consultations/consultations"

export default {
    name: 'manage-interpretation',
    components: {
        VueEditor
    },
    props: {
        selected_examen: Object,
        user_info: Object,
        toggler: Number
    },
    data() {
        return {
            asset_url: '',
            customToolbar: vueEditorToolbar,
            liste_modeles: [],
            selected_modele: '',
            interpretation: '',

            mdl_loading: true,
            mdl_empty: false,
            mdl_error: false,

            msg_error: "",
            save_loading: false,
            is_error: false,
            file_type: ''
        }
    },

    watch: {
        toggler() {
            this.asset_url = this.assets_path+'/files/resultats-examen'

            this.selected_modele = ''
            this.fetchModeleExamen()
            this.checkIfCanViewInFrame()
        },

        selected_modele() {
            this.msg_error = ""
            this.autoFillCompteRendu()
        }
    },

    computed: {

    },

    mounted() {
        
    },

    methods: {
        checkIfCanViewInFrame() {
            const filename = this.selected_examen.cliche
            this.file_type = 'autre'
            if (
                filename.includes('png') || 
                filename.includes('PNG') || filename.includes('jpeg') || filename.includes('JPEG') || 
                filename.includes('jpg') || filename.includes('JPG') 
            ) {
                this.file_type = 'image'
            } else if (filename.includes('pdf')) {
                this.file_type = 'pdf'
            }
            return this.file_type
        },

        fetchModeleExamen() {
            this.mdl_loading = true

            const data = {
                type_examen_id: this.selected_examen.type_examen_id
            }
            store_config.getListeModeleExamens(data).then((response) => {
                this.liste_modeles = response
                if (response.length == 0) {
                    this.mdl_empty = true
                } else {
                    this.mdl_empty = false
                }
                this.mdl_loading = false
            }).catch(() => {
                this.mdl_loading = false
                this.mdl_error = true
            })
        },

        autoFillCompteRendu() {
            let content = this.selected_modele.model_field.default_value
            content = content.replace("[NOM_MEDECIN]", this.user_info.nom)
            content = content.replace("[NOM_PATIENT]", this.selected_examen.nom_patient)
            content = content.replace("[DATE_NAISSANCE_PATIENT]", this.formatDateToDmY(this.selected_examen.date_naissance))
            content = content.replace("[AGE_PATIENT]", this.selected_examen.age)
            content = content.replace("[VILLE]", this.ville_le)
            content = content.replace("[DATE]", this.formatDateToDmY(this.selected_examen.date_demande_examen))
            content = content.replace("[NOM_CLINIQUE]", this.nom_clinique)

            this.interpretation = content
        },

        saveInterpretation() {
            this.msg_error = ""
            if (this.selected_modele == '') {
                this.msg_error = "Veuillez choisir un modèle de compte rendu ! Si ce dernier n'existe pas, veuillez en créer dans les paramètres."
                return
            }

            if (this.interpretation.trim() == '') {
                this.msg_error = "Le compte rendu ne peut pas être vide !"
                return
            }

            const data = {
                bulletin_id: this.selected_examen.bulletin_id,
                demande_id: this.selected_examen.demande_id,
                type_examen_id: this.selected_examen.type_examen_id,
                interpretation: this.interpretation,
                user_id: this.user_info.id,
                user_info: this.user_info,
                titre_interpretation: (this.selected_modele?.model_field?.champ)?this.selected_modele.model_field.champ:'',
            }
            
            this.save_loading = true

            store_consultation.saveExamenInterpretation(data).then((response) => {
                if (response.success) {
                    this.$emit("emitRefreshAttenteList")

                    this.$refs.interpret_exam.click()
                    this.successToast(response.message)
					
                } else {
                    this.msg_error = response.message
                }
				this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur s'est produite lors de l'enregistrement. Veuillez réessayer plus tard."
            })

        }
    }
}